import { render, staticRenderFns } from "./CustomCheckboxListForm.vue?vue&type=template&id=0f5ec389"
import script from "./CustomCheckboxListForm.vue?vue&type=script&lang=js"
export * from "./CustomCheckboxListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports